<script>
import ClientesService from '@/services/clientes.service';
import Utils from '@/functions/utils';
import spinnerService from '@/services/spinner.service';

export default {

  data() {
    return {
      loading: false,
      roles: [],
      showPassword: false,
      errores: {},
      usuario: {
        nombre: null,
        usuario: null,
        rol: -1,
        contrasena: null
      }
    }
  },
  mounted() {
    this.getRoles()
  },
  methods: {
    async getRoles(){
      this.roles = await ClientesService.getRoles()
    },
    btnCancelar_click(){
      this.$router.go(-1);
    },
    async btnGuardar_click(){
      if (this.loading) return;
      //VALIDACIONES
      this.errores.usuario = this.usuario.usuario == null || this.usuario.usuario.trim() == '';
      this.errores.nombre = this.usuario.nombre == null || this.usuario.nombre.trim() == '';
      this.errores.rol = this.usuario.rol == null || this.usuario.rol == -1;
      this.errores.contrasena = this.usuario.contrasena == null || this.usuario.contrasena.trim() == '';

      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;

      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          usuario: this.usuario.usuario,
          nombre: this.usuario.nombre,
          rol: this.usuario.rol,
          contrasena: this.usuario.contrasena
        };
        await ClientesService.createUsuario(obj);
        Utils.mostrarMensajeExito('El usuario se ha guardado exitosamente')
        this.usuario = {
          nombre: null,
          usuario: null,
          rol: -1,
          contrasena: null
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeAdvertencia(error.Message ||'El Usuario ingresado ya se está utilizando')
      } finally{
        spinnerService.hide();
      }
      
    }
  }

}
</script>
<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>Nuevo Usuario</h1>
            <p>REGISTRE LOS DATOS DEL NUEVO USUARIO</p>
          </div>
          <div class="card-body p-5">
            <form id="regisUser">
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="usr_nom" class="form-label form-control-lg">Nombre</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="usuario.nombre" name="usr_nom" id="usr_nom"
                      maxlength="50" v-bind:class="{ 'invalid': errores.nombre }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="usr_usr" class="form-label form-control-lg">Usuario</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="usuario.usuario" name="usr_usr" id="usr_usr"
                      maxlength="20" v-bind:class="{ 'invalid': errores.usuario }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="usr_rol" class="form-label form-control-lg">Rol</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="usr_rol" id="usr_rol" class="req form-select form-control-lg" v-model="usuario.rol" v-bind:class="{ 'invalid': errores.rol }">
                      <option value="-1">Seleccione un Rol</option>
                      <option v-for="rol in roles" :key="rol.value" :value="rol.value">{{ rol.label }}</option>

                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="usr_pas" class="form-label form-control-lg">Contraseña</label>
                  </div>
                  <div class="col-sm-7">
                    <div class="input-group mb-3">
                      <input :type="showPassword ? 'text' :'password'" class="req form-control form-control-lg" v-model="usuario.contrasena" name="usr_pas" id="usr_pas"
                        maxlength="50" v-bind:class="{ 'invalid': errores.contrasena }">
                      <button class="btn btn-outline-secondary btn-lg" type="button" id="show" @click="showPassword = !showPassword "><i
                          id="icon" class="fas" v-bind:class="{'fa-eye-slash': !showPassword,'fa-eye': showPassword}"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="cnt_fec_con" id="cnt_fec_con">
                  <div class="col"><a @click="btnCancelar_click" class="btn btn-danger form-control btn-lg">Cancelar</a></div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                    @click="btnGuardar_click">Guardar</button></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>